export default __webpack_public_path__ + "static/bg-d4a59f6d03d5c8526be95030cf358ed9.mp4";